import React, { useEffect } from 'react'
import { Layout, LayoutProps, useI18nProvider } from 'react-admin'
import AppBar from './KAppBar'
import KMenu from './KMenu'
import { getCountry } from 'services/geo-management'

const KLayout: React.FC<LayoutProps> = (props) => {
  const i18nProvider = useI18nProvider()

  const { languageCode } = getCountry()

  useEffect(() => {
    i18nProvider.changeLocale(languageCode)
  }, [languageCode, i18nProvider])

  return <Layout {...props} appBar={AppBar} menu={KMenu} />
}

export default KLayout
